/* Sophia Belle Grace PDP: How many cards and customer videos (ported from Sakina ml-pdp.js) */
(() => {
  const formatMoney = (cents, format) => {
    const value = (Number(cents) || 0) / 100;
    const withDelimiters = (num, decimals, thousands, decimal) => {
      const parts = num.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', ',');
        default: return withDelimiters(value, 2, ',', '.');
      }
    });
  };

  // Shopify rounds the discount down, so the line total rounds up
  const discounted = (cents, pct) => cents - Math.floor(cents * pct / 100);

  // "Add to cart · $55.71": the button shows the total for the chosen quantity
  const setAtcPrice = (box) => {
    const button = document.querySelector(`buy-buttons[form="${box.dataset.form}"] button[type="submit"]`);
    if (!button || button.disabled) return;
    const label = button.getAttribute('is') === 'custom-button' && button.firstElementChild ? button.firstElementChild : button;
    if (!button.dataset.sbgBase) button.dataset.sbgBase = label.textContent.trim();
    const checked = box.querySelector('input[type="radio"]:checked');
    const qty = checked ? Number(checked.value) : 1;
    const pct = checked ? Number(checked.dataset.pct) || 0 : 0;
    const total = discounted(Number(box.dataset.price) * qty, pct);
    label.textContent = `${button.dataset.sbgBase} · ${formatMoney(total, box.dataset.money)}`;
  };

  const render = (box) => {
    const price = Number(box.dataset.price);
    const compare = Math.max(Number(box.dataset.compare), price);
    const money = box.dataset.money;
    box.querySelectorAll('.sbg-qty__card').forEach((card) => {
      const radio = card.querySelector('input[type="radio"]');
      const qty = Number(radio.value);
      const pct = Number(radio.dataset.pct) || 0;
      const now = discounted(price * qty, pct);
      const was = compare * qty;
      card.querySelector('[data-now]').textContent = formatMoney(now, money);
      card.querySelector('[data-was]').textContent = was > now ? formatMoney(was, money) : '';
      card.classList.toggle('is-active', radio.checked);
    });
    setAtcPrice(box);
  };

  const apply = (box) => {
    const checked = box.querySelector('input[type="radio"]:checked');
    const input = box.querySelector('[data-sbg-qty-input]');
    if (input) input.value = checked ? Number(checked.value) : 1;
    render(box);
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-sbg-qty]').forEach((box) => {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      box.addEventListener('change', (event) => {
        if (event.target.matches('input[type="radio"]')) apply(box);
      });
      apply(box);
    });
  };

  // keep card prices and the button total in sync with the selected variant
  document.addEventListener('variant:change', (event) => {
    const variant = event.detail && event.detail.variant;
    if (!variant) return;
    document.querySelectorAll('[data-sbg-qty]').forEach((box) => {
      box.dataset.price = variant.price;
      box.dataset.compare = variant.compare_at_price || variant.price;
      setTimeout(() => render(box), 50);
    });
  });

  // customer videos: load and play muted only while on screen, pause when scrolled away
  const initUgc = (root = document) => {
    const vids = root.querySelectorAll('.sbg-ugc__vid');
    if (!vids.length) return;
    const play = (v) => {
      if (!v.src) v.src = v.dataset.src;
      const p = v.play();
      if (p && p.catch) p.catch(() => {});
    };
    if (!('IntersectionObserver' in window)) { vids.forEach(play); return; }
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (e.isIntersecting) play(e.target); else e.target.pause();
    }), { rootMargin: '200px 0px', threshold: 0.15 });
    vids.forEach((v) => io.observe(v));
  };

  // keep the sticky gallery just below the sticky header, whatever its height
  const setHeaderH = () => {
    const header = document.querySelector('.shopify-section--header');
    if (header) document.documentElement.style.setProperty('--sbg-header-h', `${Math.round(header.getBoundingClientRect().height)}px`);
  };
  setHeaderH();
  window.addEventListener('resize', setHeaderH);

  const boot = () => { init(); initUgc(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', (event) => { init(event.target); initUgc(event.target); });
})();
